import React from 'react';

export const DotLogo = () => {
  return <div className={`transition-all duration-500 w-3 h-3 lg:w-6 lg:h-6 bg-doc-text rounded-full`}></div>;
};
